import { httpRequest } from '../../../app/common/util/api-common.util';

export default class CitologiaApi {
    static adicionarLaminaDeCitologia(laminaCitologiaRequest) {
        return httpRequest("citologia", 'PUT', laminaCitologiaRequest);
    }

    static apagarLaminaDeCitologia(cdLaudo, cdLaudoLamina, justificativa) {
        let justificativaQuery = justificativa !== '' ? `?justificativa=${justificativa}` : '';
        return httpRequest(
            `citologia/laudo/${cdLaudo}/lamina-citologia/${cdLaudoLamina}${justificativaQuery}`, 'DELETE'
        );
    }

    static obterInfoLaudoNovaLaminaCitologia(nrExame) {
        return httpRequest(`citologia/nr-exame/${nrExame}`)
    }

    static delegarLaminaCitologia(idLaudolaminas, cdBlocolamina, idCitotecnico, data, laudo) {
        return httpRequest("citologia/delegar-lamina", 'PUT', {
            idCitotecnico, idLaudolaminas, cdBlocolamina, data, laudo
        }).then(json => json.data);
    }

    static obterCitotecnicos(data, ordenacao) {
        return httpRequest(`citologia/citotecnicos?data=${data}&ordenacao=${ordenacao}`)
            .then((json) => json.data);
    }
    static obterTotalLaminasDelegadasCitotecnico(data, citoTecnicoId) {
        return httpRequest(`citologia/citotecnicos/${citoTecnicoId}/total-delegadas?data=${data}`)
            .then((json) => json.data);
    }
    static obterLaminaCitologiaConsultaDetalhes(data, citoTecnicoId) {
        return httpRequest(`citologia/citotecnicos/${citoTecnicoId}/laminas?data=${data}`)
            .then((json) => json.data);
    }
}


// WEBPACK FOOTER //
// ./src/pages/citologia/content/citologia.api.js